import React, { useEffect, useState } from 'react';
import { LogOut, Cpu, User, Menu, X } from 'lucide-react';
import SaldoDisparos from '../components/shared/SaldoDisparos';

// ── Inject CSS once ──────────────────────────────────────────────────────────

const STYLE_ID = 'integrai-layout-v2';
const FONT_ID  = 'integrai-fonts-v2';

const CSS = `
  /* ─── Top bar ─── */
  .int-topbar {
    position: sticky;
    top: 0;
    z-index: 100;
    width: 100%;
    background: rgba(15,23,42,0.97);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    border-bottom: 1px solid rgba(99,102,241,0.18);
    box-shadow: 0 1px 0 rgba(99,102,241,0.08), 0 4px 32px rgba(0,0,0,0.45);
  }
  .int-topbar-inner {
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 20px;
    gap: 8px;
    max-width: 100%;
    overflow: hidden;
  }

  /* ─── Brand ─── */
  .int-brand {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 1px;
    margin-right: 4px;
  }
  .int-brand-name {
    font-family: 'Space Grotesk', system-ui, sans-serif;
    font-weight: 700;
    font-size: 18px;
    letter-spacing: -0.04em;
    background: linear-gradient(90deg, #818cf8 0%, #06b6d4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1;
    white-space: nowrap;
  }
  .int-brand-tenant {
    font-family: 'Space Grotesk', system-ui, sans-serif;
    font-size: 9px;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(99,102,241,0.55);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
  }

  /* ─── Divider ─── */
  .int-divider {
    width: 1px;
    height: 28px;
    background: rgba(99,102,241,0.15);
    flex-shrink: 0;
    margin: 0 4px;
  }

  /* ─── Center nav ─── */
  .int-nav {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 2px;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 0 4px;
    justify-content: center;
  }
  .int-nav::-webkit-scrollbar { display: none; }

  .int-navitem {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 7px 13px;
    border-radius: 8px;
    border: 1px solid transparent;
    cursor: pointer;
    background: transparent;
    white-space: nowrap;
    flex-shrink: 0;
    outline: none;
    font-family: 'Space Grotesk', system-ui, sans-serif;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.01em;
    color: rgba(148,163,184,1);
    transition: background 0.15s, border-color 0.15s, color 0.15s;
  }
  .int-navitem:hover {
    background: rgba(99,102,241,0.1);
    border-color: rgba(99,102,241,0.2);
    color: rgba(199,210,254,1);
    cursor: pointer;
  }
  .int-navitem.int-active {
    background: rgba(99,102,241,0.15);
    border-color: rgba(99,102,241,0.38);
    color: rgba(199,210,254,1);
    box-shadow: 0 0 16px rgba(99,102,241,0.18);
  }
  .int-navitem.int-active::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 24px;
    height: 2px;
    background: rgba(99,102,241,0.7);
    border-radius: 2px;
  }

  /* ─── Right actions ─── */
  .int-actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* ─── Atendente toggle ─── */
  .int-aten-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.07);
    background: rgba(255,255,255,0.04);
    cursor: pointer;
    outline: none;
    font-family: 'Space Grotesk', system-ui, sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: rgba(148,163,184,1);
    transition: background 0.15s, border-color 0.15s;
  }
  .int-aten-btn:hover {
    background: rgba(255,255,255,0.08);
    border-color: rgba(255,255,255,0.12);
  }
  .int-aten-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
    transition: background 0.2s;
  }
  .int-aten-dot.on {
    background: #22c55e;
    animation: intPulse 2s ease-in-out infinite;
  }
  .int-aten-dot.off {
    background: rgba(255,255,255,0.2);
  }

  /* ─── User avatar ─── */
  .int-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #6366f1, #06b6d4);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Space Grotesk', system-ui, sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
    cursor: default;
    user-select: none;
    box-shadow: 0 0 14px rgba(99,102,241,0.4);
  }

  /* ─── Logout ─── */
  .int-logout {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.07);
    background: rgba(255,255,255,0.04);
    cursor: pointer;
    outline: none;
    transition: background 0.15s, border-color 0.15s;
    flex-shrink: 0;
  }
  .int-logout:hover {
    background: rgba(239,68,68,0.14);
    border-color: rgba(239,68,68,0.35);
  }

  /* ─── Badge ─── */
  .int-badge {
    min-width: 17px;
    height: 17px;
    border-radius: 9px;
    background: #ef4444;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
    box-shadow: 0 0 8px rgba(239,68,68,0.5);
    flex-shrink: 0;
  }

  /* ─── Sub-nav strip ─── */
  .int-subnav {
    position: sticky;
    top: 56px;
    z-index: 99;
    width: 100%;
    background: rgba(8,12,24,0.97);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border-bottom: 1px solid rgba(99,102,241,0.1);
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 24px;
    height: 38px;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .int-subnav::-webkit-scrollbar { display: none; }

  .int-subitem {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 6px;
    cursor: pointer;
    border: 1px solid transparent;
    background: transparent;
    white-space: nowrap;
    flex-shrink: 0;
    outline: none;
    font-family: 'Space Grotesk', system-ui, sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: rgba(100,116,139,1);
    transition: all 0.15s;
  }
  .int-subitem:hover {
    background: rgba(99,102,241,0.08);
    color: rgba(148,163,184,1);
  }
  .int-subitem.int-sub-active {
    background: rgba(99,102,241,0.14);
    border-color: rgba(99,102,241,0.28);
    color: rgba(165,180,252,1);
  }

  /* ─── Hamburger ─── */
  .int-hamburger {
    display: none;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.08);
    background: transparent;
    cursor: pointer;
    outline: none;
    color: rgba(148,163,184,1);
    flex-shrink: 0;
    transition: background 0.15s;
  }
  .int-hamburger:hover {
    background: rgba(99,102,241,0.1);
  }

  /* ─── Mobile drawer ─── */
  .int-drawer-overlay {
    position: fixed;
    inset: 0;
    z-index: 200;
    background: rgba(0,0,0,0.65);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }
  .int-drawer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 272px;
    background: #0d1526;
    border-left: 1px solid rgba(99,102,241,0.2);
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow-y: auto;
    animation: intDrawerIn 0.22s cubic-bezier(0.4,0,0.2,1) forwards;
  }
  .int-drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 16px 12px;
    border-bottom: 1px solid rgba(99,102,241,0.12);
  }
  .int-drawer-nav {
    flex: 1;
    padding: 12px 12px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow-y: auto;
  }
  .int-drawer-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 12px;
    border-radius: 8px;
    border: 1px solid transparent;
    cursor: pointer;
    background: transparent;
    outline: none;
    font-family: 'Space Grotesk', system-ui, sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: rgba(148,163,184,1);
    transition: all 0.15s;
    text-align: left;
    width: 100%;
  }
  .int-drawer-item:hover {
    background: rgba(99,102,241,0.1);
    color: rgba(199,210,254,1);
  }
  .int-drawer-item.int-active {
    background: rgba(99,102,241,0.15);
    border-color: rgba(99,102,241,0.3);
    color: rgba(165,180,252,1);
  }
  .int-drawer-footer {
    padding: 12px 16px;
    border-top: 1px solid rgba(99,102,241,0.1);
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .int-drawer-user {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
  }
  .int-drawer-username {
    font-family: 'Space Grotesk', system-ui, sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: rgba(226,232,240,1);
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* ─── Content area ─── */
  .int-content {
    flex: 1;
    overflow-y: auto;
    position: relative;
    z-index: 1;
  }

  /* ─── Keyframes ─── */
  @keyframes intPulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(34,197,94,0.5); }
    60%       { box-shadow: 0 0 0 5px rgba(34,197,94,0); }
  }
  @keyframes intDrawerIn {
    from { transform: translateX(100%); }
    to   { transform: translateX(0); }
  }

  /* ─── Responsive ─── */
  @media (max-width: 768px) {
    .int-nav    { display: none; }
    .int-hamburger { display: flex; }
    .int-aten-label { display: none; }
    .int-divider { display: none; }
  }
`;

// ── Nav item (top bar) ───────────────────────────────────────────────────────

const NavItem = ({ aba, isActive, onClick, badge }) => (
  <button
    className={`int-navitem${isActive ? ' int-active' : ''}`}
    onClick={() => onClick(aba.id)}
    title={aba.label}
  >
    {(aba.Icon || aba.icon) && (
      <span style={{ display: 'flex', alignItems: 'center', opacity: isActive ? 1 : 0.7 }}>
        {React.createElement(aba.Icon || aba.icon, { size: 15 })}
      </span>
    )}
    {aba.label}
    {badge > 0 && <span className="int-badge">{badge}</span>}
  </button>
);

// ── Sub-nav item ─────────────────────────────────────────────────────────────

const SubItem = ({ subAba, isActive, onClick }) => (
  <button
    className={`int-subitem${isActive ? ' int-sub-active' : ''}`}
    onClick={() => onClick(subAba.id)}
  >
    {(subAba.Icon || subAba.icon) && (
      <span style={{ display: 'flex', alignItems: 'center' }}>
        {React.createElement(subAba.Icon || subAba.icon, { size: 12 })}
      </span>
    )}
    {subAba.label}
  </button>
);

// ── Helpers (extraídos para reduzir complexidade ciclomática) ─────────────────

function useInjectStyles() {
  useEffect(() => {
    if (!document.getElementById(FONT_ID)) {
      const link = document.createElement('link');
      link.id   = FONT_ID;
      link.rel  = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap';
      document.head.appendChild(link);
    }
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id          = STYLE_ID;
      style.textContent = CSS;
      document.head.appendChild(style);
    }
  }, []);
}

function deriveSubNav({
  abaAtiva,
  expandidoDisparo, expandidoFinanceiro,
  SUB_ABAS_DISPARO, SUB_ABAS_FINANCEIRO,
  subAbaDisparo, subAbaFinanceiro,
  setSubAbaDisparo, setSubAbaFinanceiro,
}) {
  const isDisparo = abaAtiva === 'disparo';
  const visible =
    (abaAtiva === 'disparo'    && expandidoDisparo    && SUB_ABAS_DISPARO?.length > 0) ||
    (abaAtiva === 'financeiro' && expandidoFinanceiro && SUB_ABAS_FINANCEIRO?.length > 0);
  const abas   = isDisparo ? SUB_ABAS_DISPARO  : SUB_ABAS_FINANCEIRO;
  const ativa  = isDisparo ? subAbaDisparo      : subAbaFinanceiro;
  const change = (id) => {
    if (isDisparo) setSubAbaDisparo(id);
    else setSubAbaFinanceiro(id);
  };
  return { visible, abas, ativa, change };
}

// ── Sub-componentes ───────────────────────────────────────────────────────────

const BackgroundDecorations = () => (
  <>
    <div aria-hidden="true" style={{
      position: 'fixed', inset: 0, zIndex: 0,
      backgroundImage: `
        linear-gradient(rgba(99,102,241,0.04) 1px, transparent 1px),
        linear-gradient(90deg, rgba(99,102,241,0.04) 1px, transparent 1px)
      `,
      backgroundSize: '44px 44px',
      pointerEvents: 'none',
    }} />
    <div aria-hidden="true" style={{
      position: 'fixed', top: -80, right: '15%', width: 480, height: 480,
      background: 'rgba(99,102,241,0.12)', borderRadius: '50%',
      filter: 'blur(120px)', pointerEvents: 'none', zIndex: 0,
    }} />
    <div aria-hidden="true" style={{
      position: 'fixed', bottom: 40, left: '8%', width: 320, height: 320,
      background: 'rgba(6,182,212,0.08)', borderRadius: '50%',
      filter: 'blur(90px)', pointerEvents: 'none', zIndex: 0,
    }} />
  </>
);

const BrandLogo = ({ tenant }) => (
  <div className="int-brand">
    <span className="int-brand-name">
      Integr<em style={{ fontStyle: 'italic' }}>AI</em>
    </span>
    {tenant?.nome && <span className="int-brand-tenant">{tenant.nome}</span>}
  </div>
);

const UserAvatar = ({ usuarioLogado }) => {
  const initial = usuarioLogado?.nome ? usuarioLogado.nome.charAt(0).toUpperCase() : null;
  return (
    <div className="int-avatar" title={usuarioLogado?.nome || 'Usuário'}>
      {initial || <User size={14} />}
    </div>
  );
};

const getAtendenteButtonStyle = (processando, mobile) => ({
  opacity: processando ? 0.5 : 1,
  cursor: processando ? 'wait' : 'pointer',
  ...(mobile ? { width: '100%', justifyContent: 'flex-start' } : {}),
});

const getAtendenteSpanStyle = (ativo, mobile) => ({
  fontFamily: "'Space Grotesk', system-ui, sans-serif",
  fontSize: mobile ? 13 : 12,
  fontWeight: 500,
  color: ativo ? 'rgba(134,239,172,1)' : 'rgba(100,116,139,1)',
});

const getAtendenteLabel = (ativo, mobile) => {
  if (mobile) return `Atendente ${ativo ? 'online' : 'offline'}`;
  return ativo ? 'Online' : 'Offline';
};

const AtendenteToggle = ({ atendenteAtivo, atendenteProcessando, onToggle, mobile }) => {
  if (!onToggle) return null;
  return (
    <button
      className="int-aten-btn"
      onClick={onToggle}
      disabled={atendenteProcessando}
      title={atendenteAtivo ? 'Atendente ativo — clique para pausar' : 'Atendente pausado — clique para ativar'}
      style={getAtendenteButtonStyle(atendenteProcessando, mobile)}
    >
      <Cpu size={mobile ? 14 : 13} color="rgba(148,163,184,0.8)" />
      <span className={`int-aten-dot ${atendenteAtivo ? 'on' : 'off'}`} />
      <span
        className={mobile ? undefined : 'int-aten-label'}
        style={getAtendenteSpanStyle(atendenteAtivo, mobile)}
      >
        {getAtendenteLabel(atendenteAtivo, mobile)}
      </span>
    </button>
  );
};

const SubNavStrip = ({ visible, abas, ativa, onChange }) => {
  if (!visible || !abas?.length) return null;
  return (
    <div className="int-subnav">
      {abas.map((subAba) => (
        <SubItem
          key={subAba.id}
          subAba={subAba}
          isActive={ativa === subAba.id}
          onClick={onChange}
        />
      ))}
    </div>
  );
};

const MobileDrawer = ({
  abasVisiveis,
  abaAtiva,
  tenant,
  totalNaoLidas,
  isVendedor,
  atendenteAtivo,
  atendenteProcessando,
  handleToggleAtendente,
  usuarioLogado,
  handleNavClick,
  handleLogout,
  onClose,
}) => (
  <div
    className="int-drawer-overlay"
    onClick={onClose}
    aria-modal="true"
    role="dialog"
  >
    <div
      className="int-drawer"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="int-drawer-header">
        <BrandLogo tenant={tenant} />
        <button
          onClick={onClose}
          style={{
            width: 32, height: 32, borderRadius: 8,
            border: '1px solid rgba(255,255,255,0.08)',
            background: 'transparent', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'rgba(148,163,184,1)', outline: 'none',
          }}
        >
          <X size={16} />
        </button>
      </div>

      <nav className="int-drawer-nav">
        {(abasVisiveis || []).map((aba) => (
          <button
            key={aba.id}
            className={`int-drawer-item${abaAtiva === aba.id ? ' int-active' : ''}`}
            onClick={() => handleNavClick(aba.id)}
          >
            {(aba.Icon || aba.icon) && (
              <span style={{ display: 'flex', alignItems: 'center', opacity: 0.8 }}>
                {React.createElement(aba.Icon || aba.icon, { size: 17 })}
              </span>
            )}
            <span style={{ flex: 1 }}>{aba.label}</span>
            {aba.id === 'atendimento' && totalNaoLidas > 0 && (
              <span className="int-badge">{totalNaoLidas}</span>
            )}
          </button>
        ))}
      </nav>

      <div className="int-drawer-footer">
        {!isVendedor && (
          <AtendenteToggle
            atendenteAtivo={atendenteAtivo}
            atendenteProcessando={atendenteProcessando}
            onToggle={handleToggleAtendente ? () => { handleToggleAtendente(); onClose(); } : null}
            mobile
          />
        )}
        <div className="int-drawer-user">
          <UserAvatar usuarioLogado={usuarioLogado} />
          <span className="int-drawer-username">
            {usuarioLogado?.nome || 'Usuário'}
          </span>
          <button
            className="int-logout"
            onClick={() => { handleLogout(); onClose(); }}
            title="Sair"
          >
            <LogOut size={14} color="rgba(148,163,184,0.7)" />
          </button>
        </div>
      </div>
    </div>
  </div>
);

// ── Main layout ───────────────────────────────────────────────────────────────

export default function LayoutIntegrAI({
  abasVisiveis,
  abaAtiva,
  handleTrocarAba,
  subAbaDisparo,
  setSubAbaDisparo,
  subAbaFinanceiro,
  setSubAbaFinanceiro,
  expandidoDisparo,
  expandidoFinanceiro,
  SUB_ABAS_DISPARO,
  SUB_ABAS_FINANCEIRO,
  usuarioLogado,
  tenant,
  totalNaoLidas,
  atendenteAtivo,
  atendenteProcessando,
  handleToggleAtendente,
  handleLogout,
  children,
}) {
  const [menuAberto, setMenuAberto] = useState(false);

  useInjectStyles();

  useEffect(() => {
    if (!menuAberto) return;
    const onKey = (e) => { if (e.key === 'Escape') setMenuAberto(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [menuAberto]);

  const isVendedor = usuarioLogado?.perfil === 'vendedor';

  const subNav = deriveSubNav({
    abaAtiva,
    expandidoDisparo, expandidoFinanceiro,
    SUB_ABAS_DISPARO, SUB_ABAS_FINANCEIRO,
    subAbaDisparo, subAbaFinanceiro,
    setSubAbaDisparo, setSubAbaFinanceiro,
  });

  const handleNavClick = (id) => {
    handleTrocarAba(id);
    setMenuAberto(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0B1120',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      fontFamily: "'Space Grotesk', system-ui, sans-serif",
    }}>
      <BackgroundDecorations />

      <header className="int-topbar" style={{ position: 'sticky', top: 0, zIndex: 100 }}>
        <div className="int-topbar-inner">
          <BrandLogo tenant={tenant} />
          <div className="int-divider" />

          <nav className="int-nav" aria-label="Navegação principal">
            {(abasVisiveis || []).map((aba) => (
              <NavItem
                key={aba.id}
                aba={aba}
                isActive={abaAtiva === aba.id}
                onClick={handleTrocarAba}
                badge={aba.id === 'atendimento' ? totalNaoLidas : 0}
              />
            ))}
          </nav>

          <div className="int-divider" />

          <div className="int-actions">
            <SaldoDisparos tenantId={tenant?.id} />
            {!isVendedor && (
              <AtendenteToggle
                atendenteAtivo={atendenteAtivo}
                atendenteProcessando={atendenteProcessando}
                onToggle={handleToggleAtendente}
              />
            )}
            <UserAvatar usuarioLogado={usuarioLogado} />
            <button className="int-logout" onClick={handleLogout} title="Sair">
              <LogOut size={14} color="rgba(148,163,184,0.7)" />
            </button>
            <button className="int-hamburger" onClick={() => setMenuAberto(true)} aria-label="Abrir menu">
              <Menu size={18} />
            </button>
          </div>
        </div>
      </header>

      <SubNavStrip
        visible={subNav.visible}
        abas={subNav.abas}
        ativa={subNav.ativa}
        onChange={subNav.change}
      />

      {menuAberto && (
        <MobileDrawer
          abasVisiveis={abasVisiveis}
          abaAtiva={abaAtiva}
          tenant={tenant}
          totalNaoLidas={totalNaoLidas}
          isVendedor={isVendedor}
          atendenteAtivo={atendenteAtivo}
          atendenteProcessando={atendenteProcessando}
          handleToggleAtendente={handleToggleAtendente}
          usuarioLogado={usuarioLogado}
          handleNavClick={handleNavClick}
          handleLogout={handleLogout}
          onClose={() => setMenuAberto(false)}
        />
      )}

      <main
        className="int-content"
        style={{ flex: 1, overflowY: 'auto', position: 'relative', zIndex: 1 }}
      >
        {children}
      </main>
    </div>
  );
}
